import type { AnyFormFinalSetupObject } from "../../../../widgetDataTs.js";


export function doesUsePageOfferId (widgetSetup: AnyFormFinalSetupObject): boolean
{
  return widgetSetup?.tracking?.usePageOfferId === true;
}
